import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';


ReactDOM.render(
  <React.StrictMode>

    <App />
    <section className="footer1 cid-qEsj1x8oQy" id="footer1-c">
      <div className="container">
        <div className="mbr-col-sm-12 align-center mbr-white">
          <p className="mbr-text mbr-fonts-style display-7" style={{ fontSize: '12px', lineHeight: '20px' }}> Built by <a target="_blank" rel="noopener noreferrer" href="https://seif.rocks">Seif Elmughrabi</a> using react and netlify</p>
        </div>

      </div>
    </section>
  </React.StrictMode>,
  document.getElementById('root')
);
